import { render, staticRenderFns } from "./LahanAssestment.vue?vue&type=template&id=77d99c10"
import script from "./LahanAssestment.vue?vue&type=script&lang=js"
export * from "./LahanAssestment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports